"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFontFaces = exports.patchFontDisplay = void 0;
const fontFaceRegex = new RegExp('@font-face.*?font-family:\\s?["\']([^"\']*?)["\'].*?\\}', 'gms');
const patchFontDisplay = (fontDisplay, fontFamilyToFontFaces) => {
    const patchedFonts = { ...fontFamilyToFontFaces };
    Object.keys(patchedFonts).forEach((font) => {
        patchedFonts[font] = patchedFonts[font].map((fontString) => fontString.replace(/[ \t]*font-display:[^;]*;\n?/, '').replace('}', `font-display: ${fontDisplay};\n}`));
    });
    return patchedFonts;
};
exports.patchFontDisplay = patchFontDisplay;
const parseFontFaces = (cssString) => {
    let match;
    const tahat = {};
    // eslint-disable-next-line no-cond-assign
    while ((match = fontFaceRegex.exec(cssString)) !== null) {
        const fontFamily = match[1].toLowerCase();
        tahat[fontFamily] = tahat[fontFamily] || [];
        tahat[fontFamily].push(match[0]);
    }
    return tahat;
};
exports.parseFontFaces = parseFontFaces;
//# sourceMappingURL=fontsParser.js.map